module.exports = __webpack_public_path__ + "01f43047/img/settings-icon.121d9519.svg";